// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle-module--section-title--3MVuM"};